import React, {Children, isValidElement, useCallback, useEffect, useState} from 'react';
import CustomAlert from './CustomAlert';

function messageText(children) {
  return Children.toArray(children).map(child => isValidElement(child)
    ? messageText(child.props.children)
    : typeof child === 'string' || typeof child === 'number' ? String(child) : '').join(' ');
}

// Keep web inline validation intact; desktop messages use the window banner layer.
export default function DesktopAwareNotification({as: Tag = 'p', children, ...props}) {
  const [visible, setVisible] = useState(true);
  const dismiss = useCallback(() => setVisible(false), []);
  const message = messageText(children);
  useEffect(() => setVisible(true), [message]);
  if (!window.desktopAPI) return <Tag {...props}>{children}</Tag>;
  return visible ? <CustomAlert message={children} type="error" position="top" autoCloseMs={4000} onClose={dismiss}/> : null;
}
